/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Subheader/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Subheader({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/SimilarPatients/Content/Content/Subheader"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Subheader.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z2sUFFf': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-2-Z2sUFFf': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconWarning
  viewPath={`${viewPath}/TysiaIconWarning`}
 marginBottom={dtSpaceS}
 width={dtSpaceXl}
 height={dtSpaceXl}
 fill="#E9B949"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="This person may already exist in the system."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 color={dtColorsNeutral500}
 text="Select a matching profile or click ‘None of the above’ to proceed with registering a new patient."
/>
</div>
{children}
</React.Fragment>)
}